import { UiState } from "./types";

import {
    UI_RESET,
    UI_BUSY,
    UI_TITLE,
    UI_SUBTITLE,
    UI_HEADERCLASS,
    UI_FOOTERCLASS,
    UI_BODYCLASS,
    UI_SHOW_PAGE_HEADER,
    UI_SHOW_PAGE_FOOTER,
    UI_INIT_I18N,
    UI_I18N_LANG,
    UI_I18N_LANGS,
    UI_LOGO_LANG,
    UI_I18N_COUNTRIES,
    UI_I18N_CURRENCIES,
    UI_I18N_EINHEITENSYSTEME,
    UI_USER,
    UI_MESSAGE,
    UI_MESSAGES,
    UI_USERLIST_MODE,
    UiActionTypes,
    UI_USERLIST_FILTER
} from "./actiontypes";

export const USERLIST_MODE_STORAGE_KEY = 'wikus.paramaster.ui.userlist.mode';
export const USERLIST_FILTER_STORAGE_KEY = 'wikus.paramaster.ui.userlist.filter';

const initialState: UiState = {
    busy: 0,
    title: "ParaMaster",
    subTitle: "",
    gaId: 'G-WVWQFELLCQ',
    headerClass: "",
    footerClass: "",
    bodyClass: "",
    showPageHeader: true,
    showPageFooter: true,
    i18nInitialized: false,
    lang: navigator.language || (navigator as any).userLanguage || 'en',
    langs: [navigator.language || (navigator as any).userLanguage || 'en',],
    logoLang: navigator.language || (navigator as any).userLanguage || 'en',
    countries: ['DE'],
    currencies: ['EUR'],
    einheitensysteme: new Map(),
    messages: [],
    userlistMode: window.localStorage.getItem(USERLIST_MODE_STORAGE_KEY) || 'signups',
    userlistFilter: window.localStorage.getItem(USERLIST_FILTER_STORAGE_KEY) || '',
};

type IuActions = UiActionTypes;

export function uiReducer(state = initialState, action: IuActions): UiState {
    switch (action.type) {
        case UI_RESET:
            return {
                ...initialState,
            };

        case UI_BUSY:
            let uiBusy = action.busy ? (state.busy += 1) : (state.busy -= 1);
            if (uiBusy < 0) {
                uiBusy = 0;
            }
            return {
                ...state,
                busy: uiBusy,
            };

        case UI_TITLE:
            return {
                ...state,
                title: action.title,
            };

        case UI_SUBTITLE:
            return {
                ...state,
                subTitle: action.subTitle,
            };

        case UI_HEADERCLASS:
            return {
                ...state,
                headerClass: action.cssClass,
            };

        case UI_FOOTERCLASS:
            return {
                ...state,
                footerClass: action.cssClass,
            };

        case UI_BODYCLASS:
            return {
                ...state,
                bodyClass: action.cssClass,
            };

        case UI_SHOW_PAGE_HEADER:
            return {
                ...state,
                showPageHeader: action.show,
            };

        case UI_SHOW_PAGE_FOOTER:
            return {
                ...state,
                showPageFooter: action.show,
            };

        case UI_INIT_I18N:
            return {
                ...state,
                i18nInitialized: action.initialized,
            };

        case UI_I18N_LANG:
            return {
                ...state,
                lang: action.lang,
            };

        case UI_I18N_LANGS:
            return {
                ...state,
                langs: action.langs,
            };

        case UI_LOGO_LANG:
            return {
                ...state,
                logoLang: action.logoLang
            }

        case UI_I18N_COUNTRIES:
            return {
                ...state,
                countries: action.countries,
            };

        case UI_I18N_CURRENCIES:
            return {
                ...state,
                currencies: action.currencies,
            };

        case UI_I18N_EINHEITENSYSTEME:
            return {
                ...state,
                einheitensysteme: action.einheitensysteme,
            };

        case UI_USER:
            return {
                ...state,
                user: action.user
            };

        case UI_MESSAGE:
            return {
                ...state,
                messages: [
                    ...state.messages,
                    action.message
                ]
            };

        case UI_MESSAGES:
            return {
                ...state,
                messages: [
                    ...action.messages
                ]
            };

        case UI_USERLIST_MODE:
            window.localStorage.setItem(USERLIST_MODE_STORAGE_KEY, action.mode);
            return {
                ...state,
                userlistMode: action.mode
            };

        case UI_USERLIST_FILTER:
            window.localStorage.setItem(USERLIST_FILTER_STORAGE_KEY, action.filter);
            return {
                ...state,
                userlistFilter: action.filter
            };

        default:
            return state;
    }
}
